var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormSelect',{attrs:{"name":_vm.$t('meta.vehicle'),"value":_vm.value,"loading":_vm.loading,"disabled":_vm.disabled,"required":_vm.required,"options":_vm.vehicleOptions},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }